module.exports = __webpack_public_path__ + "img/logo_phase03-1024x565.06c8f0ef.png";